var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeopleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 25.16H0.105014C0.0423324 24.1228 0.106137 23.0818 0.295016 22.06C1.12002 18.385 3.045 16.145 6.06 15.365C6.4429 15.2722 6.83607 15.2285 7.23001 15.235C9.60668 15.235 11.9817 15.235 14.355 15.235C17.83 15.235 20.855 18.43 21.4 22.67C21.455 23.095 21.475 23.53 21.49 23.96C21.505 24.39 21.5 24.745 21.5 25.16Z",
    fill: "#9F9F9F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.165 7.215C17.164 8.47486 16.7895 9.70614 16.0887 10.7531C15.3879 11.8001 14.3924 12.6158 13.2281 13.097C12.0638 13.5782 10.7828 13.7034 9.54737 13.4566C8.3119 13.2099 7.17736 12.6023 6.2872 11.7107C5.39704 10.8192 4.79123 9.68367 4.54641 8.44782C4.30159 7.21197 4.42876 5.93127 4.9118 4.76768C5.39484 3.6041 6.21207 2.60988 7.26016 1.91076C8.30825 1.21164 9.54012 0.83901 10.8 0.839998C11.6369 0.839338 12.4657 1.00385 13.2389 1.32412C14.0121 1.64438 14.7145 2.11409 15.3058 2.70633C15.8971 3.29856 16.3657 4.00168 16.6847 4.77537C17.0038 5.54906 17.167 6.37811 17.165 7.215Z",
    fill: "#9F9F9F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleIcon);
export default __webpack_public_path__ + "static/media/peopleIcon.d23ea2e5a4adc5c453e3d1ad14862d89.svg";
export { ForwardRef as ReactComponent };